<div class="nf-page-header">
  <div class="page-title">
    Mentions
  </div>
</div>


<div class="scroll-content">
  <div class="middle-block">
    <div class="date-blocks">
      <div class="date-block" *ngFor="let notificationEntry of (mentionMap$ | async) | keyvalue : returnZero">
        <div class="date-title">
          <span class="date-span">{{notificationEntry.key | date:'MMMM d'}}</span>
        </div>
        <div class="nfs-block">
          <div *ngFor="let notification of notificationEntry.value">

            <app-notification [userNfs]="notification" [fullPage]="true"></app-notification>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-block">
    <p-paginator [rows]="limit" [totalRecords]="totalElements$ | async" (onPageChange)="onPageChange($event)"></p-paginator>

  </div>
</div>
